import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
    formPreview: false
};

const formEditorSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setFormPreview: (state, action) => {
            state.formPreview = action.payload;
        }

    }
});

export const { setFormPreview } = formEditorSlice.actions;

export default formEditorSlice.reducer;